// extracted by mini-css-extract-plugin
export default {"active":"FShDa3C1sQQdxkmhw0VF","DL":"yhyxYzhW2Ag8GfsPTugF","text":"Zy0TcBj7KqwVaRCGtPYw"};